import { Spinner, SpinnerSize } from "@fluentui/react";
import { useContext } from "react";
import { ThemeContext } from "@fluentui/react-theme-provider";
import Auth from "../../Auth/Auth";
import * as Style from "./ActiveSavingPlansStyle";
import TableActiveSavingPlans from "./TableActiveSavingPlans/TableActiveSavingPlans";
import React from "react";
import { ITableSPlansActive } from "./types/SavePlansTypes";

const CancelledSavingPlans = ({data, loading, activePlan, error}: {data?: ITableSPlansActive[], loading: boolean, activePlan: any, error: any}) =>
{
    var columns = [
        "Planes de Cartera y Carteras Modelo Asociadas",
        "Fecha Inicio",
        "Fecha de Validez",
        "Tipo de Plan",
        "Acciones"
    ];
    const theme = useContext(ThemeContext);
    const userId = Auth.getUserProfile().id;

    if (error.message)
    {
        return(
            <div>
                Error:{" "}
                {
                    // @ts-ignore
                    error.message
                }
            </div>
        );
    }
    return(
        <React.Fragment>
            <React.Fragment>
                <Style.Wrapper>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md8">
                            <Style.TitleContainer>
                                <h3 style={{marginTop: "1.4em", cursor: "default"}}>
                                    Mis planes de cartera cancelados
                                </h3>
                            </Style.TitleContainer>
                        </div>
                    </div>
                    <Style.MainCont>
                        <Style.TableCont>
                            <Style.SubTitle theme={theme}>
                                Planes de Cartera ({data?.length}) y Carteras Modelo
                            </Style.SubTitle>
                            <Style.TableContainer theme={theme}>
                                {loading === true && <Spinner size={SpinnerSize.large} />}
                                {loading === false &&
                                (
                                    <TableActiveSavingPlans
                                        theme={theme}
                                        columnTitles={columns}
                                        userId={userId}
                                        onlyShowing={6}
                                        rowData={data as ITableSPlansActive[]}
                                        activePlan={activePlan}
                                    />
                                )}
                            </Style.TableContainer>
                        </Style.TableCont>
                    </Style.MainCont>
                </Style.Wrapper>
            </React.Fragment>
        </React.Fragment>
    );
};

export default CancelledSavingPlans;